import { AddCircle } from '@mui/icons-material';
import { Button, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { InvoiceSendingTypeIntegerEnum } from 'src/shared/models/enums/invoiceSendingTypeInteger.enum';
import { InvoiceMissionApproveButtons } from './invoiceMissionApproveButtons';

type InvoiceMissionReminderButtonProps = {
  reminder: number;
  prevoiusSendingHasBeenSent: number;
  totalCount: number;
  totalCountSent: number;
  disableCreate: boolean;
  approvalRequired: boolean;
  isApproved: boolean;
  invoiceMissionId: number;
  loading: boolean;
  setOpenDeliveryMethodModal: (openDeliveryMethod: boolean) => void;
  setOpenCreateInvoiceReminderModal: (openCreateReminder: boolean) => void;
  refetchMission: (refetch: boolean) => void;
};

export const InvoiceMissionReminderButton = (props: InvoiceMissionReminderButtonProps) => {
  const {
    reminder,
    prevoiusSendingHasBeenSent,
    totalCount,
    totalCountSent,
    disableCreate,
    approvalRequired,
    isApproved,
    invoiceMissionId,
    loading,
    setOpenDeliveryMethodModal,
    setOpenCreateInvoiceReminderModal,
    refetchMission,
  } = props;

  const { t } = useTranslation();

  const isTemplateNotApproved = disableCreate;
  const isPreviousSendingNotSent = !(prevoiusSendingHasBeenSent > 0 && totalCount === 0);
  let tooltipText = '';

  if (totalCount !== 0) {
    if (totalCountSent >= totalCount) {
      return null;
    }

    if (approvalRequired === true && !isApproved) {
      return (
        <InvoiceMissionApproveButtons
          invoiceMissionId={invoiceMissionId}
          sendingType={reminder === 1 ? InvoiceSendingTypeIntegerEnum.Reminder1 : InvoiceSendingTypeIntegerEnum.Reminder2}
          refetchMission={refetchMission}
        />
      );
    }

    if (prevoiusSendingHasBeenSent > 0 && totalCountSent < totalCount) {
      return (
        <Button size='medium' variant='outlined' disabled={loading} onClick={() => setOpenDeliveryMethodModal(true)}>
          {t('invoice:invoiceMissionPage.sendReminder')}
        </Button>
      );
    }
  }

  if (isTemplateNotApproved && prevoiusSendingHasBeenSent) {
    tooltipText = t('invoice:invoiceMissionPage.templateNotApproved');
  } else if (isPreviousSendingNotSent) {
    if (reminder === 1) {
      tooltipText = t('invoice:invoiceMissionPage.mainSendingNotSent');
    } else if (reminder === 2) {
      tooltipText = t('invoice:invoiceMissionPage.reminder1NotSent');
    }
  }

  return (
    <Tooltip title={tooltipText} disableHoverListener={!isTemplateNotApproved && !isPreviousSendingNotSent}>
      <span>
        <Button
          onClick={() => setOpenCreateInvoiceReminderModal(true)}
          size='medium'
          disabled={loading || disableCreate || !(prevoiusSendingHasBeenSent > 0 && totalCount === 0)}
          variant='contained'
          color='primary'
          startIcon={<AddCircle fontSize='small' />}
          disableElevation
        >
          {t('invoice:invoiceMissionPage.createReminder', { reminder })}
        </Button>
      </span>
    </Tooltip>
  );
};
